<template>
  <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button
        class="layout-menu-button layout-topbar-action"
        @click="onMenuToggle"
      >
        <i class="pi pi-bars"></i>
      </button>
      <router-link to="/" class="layout-topbar-logo">
        <div class="ms-3" style="height: 35px">
          <img
            src="/assets/images/logo/Docs-noword-nospace.svg"
            alt="Docs"
            width="100%"
            height="100%"
          />
        </div>
      </router-link>
    </div>

    <div class="layout-topbar-actions">
      <div class="layout-config-menu d-none d-lg-flex">
        <HubSelector />
        <LanguageSelector v-has-permission="'view:translations'" />
        <Divider layout="vertical" />
      </div>
      <UserMenu />
    </div>
  </div>
</template>

<script setup>
import { useLayout } from "@/layout/composables/layout"
import LanguageSelector from "@/components/misc/LanguageSelector.vue"
import HubSelector from "@/components/misc/HubSelector.vue"
import UserMenu from "@/components/misc/UserMenu.vue"
import { computed, watch, onMounted, ref } from "vue"
import { useRoute, useRouter } from "vue-router"

const route = useRoute()
const router = useRouter()
const { onMenuToggle, layoutState } = useLayout()

const closeMenu = computed(() => route?.name === "document-analytics" || false)

onMounted(() => {
  if (closeMenu.value && !layoutState.staticMenuDesktopInactive) {
    onMenuToggle()
  }
})

watch(closeMenu, (value) => {
  if (value && !layoutState.staticMenuDesktopInactive) {
    onMenuToggle()
  }
})

router.beforeEach((to, from) => {
  if (
    from.name === "document-analytics" &&
    to.name !== "document-analytics" &&
    layoutState.staticMenuDesktopInactive
  ) {
    onMenuToggle()
  }
})
</script>
